import { createFileRoute } from '@tanstack/react-router';

import { BankTab } from '@/features/account/bank/BankTab';

export const Route = createFileRoute('/account/banque')({
  component: BankTab,
});
